module.exports = "<!-- Copyright (C) 2016 NooBaa -->\n\n<div class=\"layout-wrapper column\"\n    ko.component=\"layout\"\n    ko.css=\"layout\"\n    ko.globalCss=\"css\"\n></div>\n<modal-manager></modal-manager>\n\n";
